<template>
    <div class="user-lists-modal edit-list-spot-caption-dialog">

        <!-- Shadow -->
        <div class="user-lists-modal__shade" @click="closeModal"></div>

        <!-- Modal -->
        <div class="user-lists-modal__inner">

            <!-- Close Modal -->
            <span class="user-lists-modal__close" @click="closeModal">
                <svg class='close'><use xlink:href="#close"></use></svg>
            </span>

            <!-- Title -->
            <h2 style="font-size: 60px; margin: 20px 20px 40px 20px;"
                v-if="currentSpot"
                v-text="currentSpot.title">
            </h2>

            <p style="margin-bottom: 10px">Add some notes about this spot</p>

            <!-- Form -->
            <form :action="`/${authUser.username}/lists/${list.slug}/spots/${currentSpot?.slug}`" method="post" @submit.prevent="submit">

                <!-- Note -->
                <div>
                    <div style="margin: 10px;">
                        <textarea id="caption"
                                  rows="7"
                                  ref="inputCaption"
                                  v-model="form.caption"
                                  name="caption"
                                  placeholder="Add notes">
                        </textarea>
                    </div>
                    <div class="error" v-if="form.errors.caption" v-text="form.errors.caption"></div>
                </div>

                <!-- Submit Button -->
                <div class="form__button">
                    <button type="submit"
                            :class="{ 'is-submitting dis': form.isSubmitted }"
                            :disabled="form.isSubmitted"
                            class="button">
                        {{ form.isSubmitted ? 'Saving' : 'Save' }}

                        <svg class="arrow-right-2"><use xlink:href="#arrow-right-2"></use></svg>
                    </button>
                </div>

            </form>
        </div>

    </div>
</template>
<script>

import Helpers from "@/mixins/Helpers"
import Form from "@/classes/Form"

export default {

    mixins:[Helpers],

    props:['list'],

    data(){
        return {
            isOpen: false,
            currentSpot: null,
            form: new Form({
                caption: '',
            }).dontClear(),
        }
    },

    created() {
        eventBus.$on('open-edit-caption-dialog', spot => {
            let caption = spot.hasOwnProperty('note') ? spot.note : spot.pivot.caption
            this.currentSpot = spot
            this.form.caption = caption
            this.openModal()
            this.focusAtEnds()
        })
    },

    methods: {

        submit() {
            this.form.patch(`/lists/${this.list.id}/spot/${this.currentSpot.slug}/update-caption`, this.form)
                .then(response => {
                    eventBus.$emit('spot-' + this.currentSpot.id + '-caption-updated', response.spot.pivot.caption)
                    this.closeModal()
                })
        },

        focusAtEnds() {
            this.$nextTick(() => {
                const end = this.$refs.inputCaption.value.length
                this.$refs.inputCaption.setSelectionRange(end, end);
                this.$refs.inputCaption.focus();
            })
        },

        openModal() {
            $('.edit-list-spot-caption-dialog').fadeIn()
            let timeout = setTimeout(() => {
                document.body.classList.add('no-scroll')
                clearTimeout(timeout)
            }, 500)
        },

        closeModal() {
            document.body.classList.remove('no-scroll')
            $('.edit-list-spot-caption-dialog').fadeOut();
        },

        strLimit(str) {
            if (str.length >= 25) {
                return str.substring(0, 25) + '...'
            }
            return str
        },
    },

    computed: {
        ownsList() {
            return window.config.isLoggedIn && window.config.user.id == this.list.user_id;
        },
    }
}
</script>
